module.exports = __webpack_public_path__ + "img/search_section.eaf88ae8.png";